var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLampFloor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M381.967 212.75L310.853 20.75C306.355 8.375 294.482 0 281.234 0H102.765C89.517 0 77.769 8.375 73.146 20.75L2.033 212.75C-5.715 233.625 9.656 256 31.652 256H168.254V464H88C74.746 464 64 474.744 64 488C64 501.254 74.746 512 88 512H296C309.254 512 320 501.254 320 488C320 474.744 309.254 464 296 464H215.746V256H352.347C374.344 256 389.715 233.625 381.967 212.75ZM54.523 208L113.763 48H270.236L329.476 208H54.523Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampFloor);
export default __webpack_public_path__ + "static/media/lamp-floor.944790c6bf791e2a5d63435068d3e6d5.svg";
export { ForwardRef as ReactComponent };